// extracted by mini-css-extract-plugin
export default {"root":"notifications_root__vkrwh","description":"notifications_description__qUWtl","title":"notifications_title__JOoaH","closeButton":"notifications_closeButton__h96ZV"};